import { ActivityIndicator } from 'react-native';
import { Flex } from '@banhala/ui-kit';

/**
 * GoodsDetail 진입(navigation.push) 시 첫 commit 을 가볍게 유지하기 위한 로딩 플레이스홀더.
 *
 * 무거운 `GoodsDetailContents` 트리(섹션/이미지/SVG 다수)를 첫 렌더에 바로 그리면
 * JS 스레드가 막혀 push 애니메이션 시작이 지연된다. 이 가벼운 트리만 먼저 그려
 * 애니메이션이 즉시 시작되게 하고, 실제 콘텐츠는 전환 종료 후 마운트한다.
 */
export const GoodsDetailContentsSkeleton = () => {
  return (
    <Flex
      flex={1}
      justifyContent={'center'}
      alignItems={'center'}
      backgroundColor={'white'}
    >
      <ActivityIndicator />
    </Flex>
  );
};
